// Signup Steps
export const EMAIL_PASSWORD = 'email_password';
export const MY_PROFILE = 'my_profile';
